import axios from "axios";
import Axios from "axios";
import { accessToken, getKey } from "./sessionKey";

let API_ROOT: string = "https://devenvservice.careinfosolutions.com";

const AxiosInstance = async () => {
  // let response;
  // const baseURL: any = getKey("baseUrl")
  // if (baseURL) {
  //   API_ROOT = JSON.parse(baseURL).value.domain
  // } else {
  //   try {
  //     response = await axios.get("https://tenantcontrolservice.careinfosolutions.com/base-url/");
  //     API_ROOT = response?.data?.domain;
  //   } catch (error) {
  //     console.error("Error fetching base URL:", error);
  //   }
  // }
  const instance = Axios.create({
    baseURL: API_ROOT,
    headers: {
      "Content-Type": "application/json",
    },
  });

  instance.interceptors.request.use(
    function (config) {
      config.headers["x-requested-with"] = "";
      const schemaName = getKey("schema_name");
      if (schemaName) {
        config.headers["X-Tenant-Schema"] = schemaName;
      }
      config.headers.authorization = accessToken()
        ? `JWT ${accessToken()}`
        : null;
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      const { response } = error;
      if (response) {
        if (response.status === 404) {
          // Handle 404 error
        } else if (response.status === 401) {
          if (window.location.pathname !== "/auth-login") {
            window.localStorage.removeItem("token");
            window.location.replace("/auth-login");
          }
        } else {
          // Handle other errors
        }
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

// Export AxiosInstance and a function to get API_ROOT for use in other modules
const getApiRoot = async () => {
  if (!API_ROOT) {
    await AxiosInstance();
  }
  return API_ROOT;
};

export { AxiosInstance, getApiRoot };

// Ensure AxiosInstance is called immediately to set up the instance
(async () => {
  const instance = await AxiosInstance();
})();
